import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useAppDispatch, useAppSelector } from 'src/hooks'
import { openWindow, State } from 'src/redux'

enum legacyOsAdapterFunction {
  openAppFromOldFront = 'openAppFromOldFront'
}

interface legacyOsAdapterFunctionTypeMap {
  [legacyOsAdapterFunction.openAppFromOldFront]: {
    windowId: string
    path?: string
  }
}

// type legacyOsMessageData<T extends legacyOsAdapterFunction> = {
//   funct: T
// } & legacyOsAdapterFunctionTypeMap[T]

// type Data = legacyOsMessageData<legacyOsAdapterFunction>

type Data = legacyOsAdapterFunctionTypeMap[legacyOsAdapterFunction] & {
  funct: legacyOsAdapterFunction
}

const useLegacyOsAdapters = () => {
  const dispatch = useAppDispatch()
  const { apps } = useAppSelector((state: State) => state.desktop)

  const { t } = useTranslation()

  const funcLogicMap: {
    [key in keyof legacyOsAdapterFunctionTypeMap]: (
      params: legacyOsAdapterFunctionTypeMap[key]
    ) => void
  } = {
    [legacyOsAdapterFunction.openAppFromOldFront]: ({ path, windowId }) => {
      const appToOpen = apps.find((app) => app.id === windowId)
      if (!appToOpen) return
      if (!appToOpen.allowOpen) {
        return toast.error(t('errors.dont_have_authorization_to_open_this_app'))
      }
      dispatch(
        openWindow({
          name: appToOpen.name,
          minimized: false,
          maximized: false,
          icon: appToOpen.icon,
          iFrame: path ?? appToOpen.iFrame
        })
      )
    }
  }

  const handleIframeMsg = (event: MessageEvent) => {
    const data: Data & any = event.data
    if (typeof data === 'object' && 'funct' in data) {
      console.log(data)
      const { funct, ...params } = data as Data
      funcLogicMap[funct]?.(params as any)
    }
  }

  useEffect(() => {
    const openAppFromOldFront = (id: string, url?: string) => {
      const appToOpen = apps.find((app) => app.id === id)!
      console.log(appToOpen)
      if (!appToOpen.allowOpen) {
        return toast.error(t('errors.dont_have_authorization_to_open_this_app'))
      }
      dispatch(
        openWindow({
          name: appToOpen.name,
          minimized: false,
          maximized: false,
          icon: appToOpen.icon,
          iFrame: url ?? appToOpen.iFrame
        })
      )
    }

    window.openAppFromOldFront = openAppFromOldFront

    window.addEventListener('message', handleIframeMsg)
    return () => {
      window.removeEventListener('message', handleIframeMsg)
    }
  }, [apps])

  return {}
}

export default useLegacyOsAdapters
